import React, { useMemo, useRef } from 'react';
import { Row, Col } from 'reactstrap';
import ReactTable from '../../custom/ReactTable';
import _ from 'lodash';
import { extractReactTableData, formatPercent, getRandomColor, print } from '../../../utils';

import PolarArea from '../../../components/charts/PolarAreaNew';
import ActionIcon from '../../custom/ActionIcon';
import styled from 'styled-components';
import CreateBreakdownUldsReport from './CreateBreakdownUldsReport';
import useUser from '../../../customHooks/useUser';

export default function FlightUlds ({
    selectedFlight,
    s_flight_id,
    d_arrival_date,
    handleViewUld,
    stationInfo,
    unmanifestedAwbs
}) {

    const { user } = useUser();
    const tableRef = useRef();
    const chartData = useMemo(() => {
        const ulds = _.get(selectedFlight, 'ulds', []);
        if (ulds.length > 0) {
            const labels = [];
            const data = [];
            const backgroundColor = [];
            for (let i = 0; i < ulds.length; i++) {
                labels.push(ulds[i].s_uld);
                data.push(
                    Math.min(
                        Number((ulds[i].progress * 100).toFixed(0)), 
                        100
                    )
                );
                backgroundColor.push(getRandomColor());
            }
            return {
                labels,
                datasets: [{
                    label: 'Breakdown by ULDs',
                    data,
                    backgroundColor
                }]
            }
        }
    }, [selectedFlight]);

    const printData = () => {
        const data = _.get(selectedFlight, 'ulds', []);
        print(
            <CreateBreakdownUldsReport 
                user={user}
                d_arrival_date={d_arrival_date}
                s_flight_id={s_flight_id}
                uldsData={data}
                stationInfo={stationInfo}
                unmanifestedAwbs={unmanifestedAwbs}
            />
        )
    }

    return (
        <>
            <Row>
                <FlexContainer>
                    <h4>Breakdown by ULD for Flight {s_flight_id}</h4>
                    <ActionIcon 
                        type='print'
                        onClick={printData}
                    />
                </FlexContainer>
            </Row>
            <Row>
                <Col md={8}>
                    <ReactTable 
                        data={_.get(selectedFlight, 'ulds', [])}
                        mapping={[{
                            name: 'Progress',
                            value: 'progress',
                            percent: true,
                            sortMethod: (a, b) => Number.parseInt(a) - Number.parseInt(b)
                        }, {
                            name: 'ULD',
                            value: 's_uld'
                        }, {
                            name: 'Manifested',
                            value: 'i_actual_piece_count',
                            number: true
                        }, {
                            name: 'Brokendown',
                            value: 'rackPieces',
                            number: true
                        }, {
                            name: 'Under',
                            value: '',
                            breakdownUnder: true,
                            number: true
                        }, {
                            name: 'Over',
                            value: '',
                            breakdownOver: true,
                            number: true
                        }, {
                            name: 'Delivered',
                            value: 'deliveredPcs',
                            number: true
                        }, {
                            name: '',
                            value: 'far fa-expand-arrows',
                            icon: true,
                            function: item => handleViewUld(item)
                        }]}
                        numRows={10}
                        reactTableRef={tableRef}
                    />
                </Col>
                {
                    selectedFlight && _.get(selectedFlight, 'ulds', []).length > 0 && 
                    <Col md={4}>
                        <Row>
                            <Col md={12} className={'text-center'}>
                                <h4>{formatPercent(selectedFlight.progress)} completed</h4>
                            </Col>
                        </Row>
                        <Row style={{ height: '450px' }}>
                            <Col md={12}>
                                <PolarArea 
                                    data={chartData}
                                    shadow={true}
                                />
                            </Col>
                        </Row>
                    </Col>
                }
            </Row>
        </>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 50px;
`;